export default __webpack_public_path__ + "img/oops.d7b752b7.svg";